function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 375.147 375.147"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#1e8e3e",
  d: "M344.96 44.48L119.147 270.293l-88.96-88.96L0 211.52l119.147 119.147 256-256z"
})));